import type { ColoredMaterial } from "@color-finder/color-finder-api/models";
import LaunchIcon from "@mui/icons-material/Launch";
import { Link, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import type { FC } from "react";
import { useAppConfig } from "../../config/app-config";
import { ImagioOpticalMaterialDataLabel } from "../dataDisplay/ImagioOpticalMaterialDataLabel";
import { NoData } from "../dataDisplay/NoData";

export interface OpticalMaterialDataProps {
  material: ColoredMaterial;
  isInternal?: boolean;
}

export const OpticalMaterialData: FC<OpticalMaterialDataProps> = ({
  material,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: ToBeEvaluated with the team
  isInternal,
}) => {
  return (
    <Grid container spacing={1}>
      <Grid size={5}>
        <Typography variant="label">Data for Optical Simulation</Typography>
      </Grid>
      <Grid size={7} alignItems="start" display="flex">
        {material.opticalMaterialData.hasLevel3Data ? (
          <OpticalMaterialDataLink material={material} />
        ) : (
          <NoData />
        )}
      </Grid>
    </Grid>
  );
};

const OpticalMaterialDataLink: FC<{ material: ColoredMaterial }> = ({
  material,
}) => {
  const [appConfig] = useAppConfig();

  return (
    <Link
      href={`${appConfig.opticalMaterialData.applicationUrl}?uvp=${material.availability.productNumber}`}
      target="_blank"
      rel="noopener"
      underline="hover"
    >
      <Typography component={"span"} fontSize="inherit">
        View <ImagioOpticalMaterialDataLabel />
        <LaunchIcon
          sx={{
            fontSize: "12pt",
            lineHeight: "1em",
            verticalAlign: "text-top",
            ml: 0.5,
          }}
        />
      </Typography>
    </Link>
  );
};
